import { styled } from '@mui/material/styles';

// MUI Box turns `width`/`height` into CSS, so <Box component="img" width={800}>
// never reaches the HTML and the browser can't reserve space before the image
// loads. styled('img') forwards them as real attributes and still takes `sx`.
const Img = styled('img')({ display: 'block' });

export default Img;
